/**
 * WordPress dependencies
 */
import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Inner dependencies.
 */
const AnimationLists = [ {
	category_label: 'Fading',
	category_name: 'fading',
	animations: [ {
		label: 'Fade In',
		name: 'fadeIn',
	}, {
		label: 'Fade In Down',
		name: 'fadeInDown',
	}, {
		label: 'Fade In Left',
		name: 'fadeInLeft',
	}, {
		label: 'Fade In Right',
		name: 'fadeInRight',
	}, {
		label: 'Fade In Up',
		name: 'fadeInUp',
	} ],
},
{
	category_label: 'Zooming',
	category_name: 'zooming',
	animations: [ {
		label: 'Zoom In',
		name: 'zoomIn',
	}, {
		label: 'Zoom In Down',
		name: 'zoomInDown',
	}, {
		label: 'Zoom In Left',
		name: 'zoomInLeft',
	}, {
		label: 'Zoom In Right',
		name: 'zoomInRight',
	}, {
		label: 'Zoom In Up',
		name: 'zoomInUp',
	} ],
} ];
const AnimationDropDown = ( { label, value, onChange } ) => {
	return <>
		<SelectControl
			label={ label }
			value={ value }
			onChange={ ( newSize ) => onChange( newSize ) }
		>
			<option value="">{ __( 'None' ) }</option>
			{ AnimationLists && AnimationLists.map( ( category ) => <optgroup label={ category.category_label } key={ `animation-cat-${ category.category_name }` }>
				{ category.animations && category.animations.map( ( animation ) => <option value={ animation.name } key={ `animation-${ animation.name }` }>{ animation.label }
				</option> ) }
			</optgroup> ) }
		</SelectControl>
	</>;
};

export default AnimationDropDown;
